import { Booking } from '@/entities/Booking'
import { BookingRequests } from '@/services/booking.requests'
const bookingService = new BookingRequests()

import Vue from 'vue'

const state = {
  read: null,
  edited: null
}

const getters = {}

const actions = {
  get ({}, { id }) {
    return new Promise((resolve, reject) => {
      bookingService.get(id).then(async (booking) => {
        resolve(booking)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  save ({ state, commit }, { id, profileId, accountId }) {
    return new Promise((resolve, reject) => {
      var read = state.read || new Booking()
      if (id) { commit('setField', { field: 'id', value: id }) }
      commit('setField', { field: 'profileId', value: profileId })
      commit('setField', { field: 'accountId', value: accountId })
      bookingService.save(read.serialize(state.edited)).then((id) => {
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  roomAccount ({}, { bookingId, roomId, accountId }) {
    return new Promise((resolve, reject) => {
      bookingService.roomAccount(bookingId, roomId, accountId).then(() => {
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setRead (state, profile) {
    state.read = profile
  },
  setField (state, { field, value }) {
    if (!state.edited) {
      state.edited = {}
      if (state.read && state.read.id) {
        Vue.set(state.edited, 'id', state.read.id)
      }
    }
    Vue.set(state.edited, field, value)
  },
  resetEdited (state) {
    state.edited = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}